import { useFeatureFlags } from "@/context/FeatureFlags";
import { UiFeatureFlagNames } from "@/gql/graphql";
import { getSerialNumberFilterSearch } from "./deviceFilterSearch";

type ViewDeviceNavigation = {
  search?: string;
  state: { resetDeviceTab: true; deviceSearch?: string };
};

export function useViewDeviceNavigation() {
  const { canUseFeatureFlag } = useFeatureFlags();
  const urlFiltersEnabled = canUseFeatureFlag(UiFeatureFlagNames.UxUpdate);

  return (serialNumber: string): ViewDeviceNavigation =>
    urlFiltersEnabled
      ? {
          search: getSerialNumberFilterSearch(serialNumber),
          state: { resetDeviceTab: true },
        }
      : { state: { resetDeviceTab: true, deviceSearch: serialNumber } };
}
